// src/components/ProjectDetail.jsx
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

import './ProjectDetail.css';

// Import images from src/assets
import img1 from '../assets/projects/H-Appointment1.jpg';
import img2 from '../assets/projects/H-Appointment2.jpg';
import img3 from '../assets/projects/H-Appointment3.jpg';
import img4 from '../assets/projects/H-Appointment4.jpg';
import img5 from '../assets/projects/H-Appointment5.jpg';
import img6 from '../assets/projects/H-Appointment6.jpg';
import img7 from '../assets/projects/H-Appointment7.jpg';

import avatar from '../assets/projects/avatar.svg';


const projectData = {
  hca: {
    title: 'Healthcare Appointment System',
    description: 'Simply browse through extensive list of trusted doctors, schedule your appointment hassle-free.',
    summary:
      'Our Healthcare Appointment System empowers users in managing their healthcare needs conveniently and efficiently. At Novacrest, we understand the challenges individuals face when it comes to scheduling doctor appointments and managing their health records. That\'s why we have designed a user-friendly platform that simplifies the process. We continuously strive to enhance our platform, integrating the latest advancements to improve user experience and deliver superior service. Our vision at NovaCrest is to create a seamless healthcare experience for every user. We aim to bridge the gap between patients and healthcare providers, making it easier for you to access the care you need, when you need it.',
    features: ['Schedule Appointments', 'Patient Booking System', 'Doctor & Specialty baesd Search', 'Access to a network of trusted healthcare professionals in your area.', 'Tailored recommendations and reminders to help you stay on top of your health.'],
    images: [img1, img2, img3, img4, img5, img6, img7],
    testimonial: {
      name: '— Dr. Aish Kaan',
      role: 'Medical Director',
      text: '"Implementing the Healthcare Appointment Booking System transformed how we serve our patients. Scheduling became seamless, no-shows dropped by 40%, and staff efficiency skyrocketed. The user-friendly interface and real-time notifications are absolute game-changers for both our team and our patients."',
      avatar: avatar,
    },
    demoUrl: 'https://demo.example.com/crm',
  },

  aibot: {
    title: 'RAG-Powered AI Chatbot Platform',
    description: 'Enterprise-grade conversational AI with Retrieval-Augmented Generation and vector database integration for accurate, knowledge-grounded responses.',
    summary:
      'Our RAG-powered AI Chatbot Platform revolutionizes enterprise knowledge management by combining large language models with proprietary data through advanced vector search capabilities. At Novacrest, we specialize in building context-aware AI assistants that deliver precise, up-to-date information while maintaining data security. Our solution integrates seamlessly with existing knowledge bases, CRMs, and internal systems, providing employees and customers with instant access to accurate information. We continuously enhance our platform with the latest advancements in semantic search, fine-tuning techniques, and hallucination prevention to ensure reliable performance. Our vision is to bridge the gap between human queries and organizational knowledge through intelligent, self-learning conversational interfaces.',
    features: [
      'Retrieval-Augmented Generation (RAG) architecture',
      'Vector database integration (Pinecone/Weaviate/Chroma)',
      'Multi-source knowledge grounding',
      'Real-time API connectivity to business systems',
      'Hallucination prevention and confidence scoring',
      'Conversational analytics dashboard',
      'Enterprise-grade security and access controls',
      'Continuous learning feedback loops'
    ],

    testimonial: {
      name: '— Sarah Chen',
      role: 'CTO, FinTech Solutions',
      text: '"The RAG-based chatbot transformed our customer support operations. It reduced resolution time by 65% while maintaining 98% accuracy by leveraging our internal knowledge bases. The vector search integration allows it to understand nuanced queries we never thought possible with traditional chatbots."',
      avatar: avatar,
    },
    demoUrl: 'https://demo.example.com/ai-chatbot',
    technicalDetails: {
      architecture: 'Microservices with Kubernetes orchestration',
      llmOptions: ['OpenAI GPT-4', 'Anthropic Claude', 'Llama 2'],
      vectorDB: 'Pinecone with hybrid search capabilities',
      security: 'SOC2 compliant with data encryption at rest and in transit',
      deployment: 'AWS EKS with auto-scaling',
      languages: ['Python', 'TypeScript', 'Nodejs', 'Rust'],
      frameworks: ['LangChain', 'LlamaIndex', 'FastAPI']
    }
  },

  videoconf: {
    title: 'Enterprise Video Conferencing System',
    description: 'High-quality, secure video conferencing with advanced collaboration features for distributed teams.',
    summary:
      'Our Enterprise Video Conferencing System redefines remote collaboration with crystal-clear audio, HD video, and seamless screen sharing capabilities.  At Novacrest, we specialize in providing high-quality video conferencing solutions that are transforming how organizations conduct meetings in the digital age. Our system scales effortlessly from one-on-one calls to large webinars with hundreds of participants, ensuring consistent performance across all use cases.',
    features: [
      'HD video with adaptive bitrate streaming',
      'Noise suppression & echo cancellation',
      'End-to-end encryption for all communications',
      'Screen sharing with annotation tools',
      'Virtual backgrounds & touch-up appearance',
      'Live captions & meeting transcripts',
      'Breakout rooms & participant management',
      'Calendar integration & scheduling',
      'Cloud recording with searchable transcripts',
      'AI-powered meeting summaries'
    ],

    testimonial: {
      name: '— Michael Rodriguez',
      role: 'Director of Remote Operations, TechGlobal Inc.',
      text: '"The Novacrest video conferencing system has become our collaboration backbone. We\'ve reduced meeting setup time by 75% while improving call quality significantly. The reliability during international calls has been exceptional, and our teams love the intuitive interface and powerful features."',
      avatar: avatar,
    },
    demoUrl: 'https://demo.example.com/ai-chatbot',

    technicalDetails: {
      architecture: 'Distributed microservices with WebRTC core',
      codecs: ['VP9', 'H.264', 'AV1'],
      security: 'End-to-end encryption with TLS 1.3, SOC2 compliant',
      deployment: 'Global edge network with AWS and Azure regions',
      platforms: ['Web', 'Windows', 'macOS', 'iOS', 'Android'],
      integrations: ['Google Calendar', 'Microsoft 365', 'Slack', 'Zoom'],
      languages: ['TypeScript', 'C++', 'Java', 'Swift'],
      frameworks: ['React', 'Node.js', 'WebRTC', 'FFmpeg']
    }
  },


  busnotify: {
    title: 'SafeRide School Bus Alert System',
    description: 'Instant emergency alerts and real-time updates for school transportation safety',
    summary: 'Our SafeRide Alert System provides instant updates,  notifications and real-time monitoring for school bus fleets. Designed for parents, schools, and transportation departments, we deliver instant alerts for emergencies, delays, and route changes with military-grade reliability to ensure student safety during transit.',
    features: [
      'Instant emergency alerts (accidents, breakdowns)',
      'Route updates',
      'Bus Cancellations and delay notifications',
      'Student Bus Registrations',

      'Admin dashboard for route management and student registration',
      'Weather emergency protocols',
      'Parent call center for emergency contact information',

    ],

    testimonial: {
      name: '— Amanda Houle',
      role: 'Transportation Director, Nation School',
      text: '"SafeRoute has transformed our school transportation operations. Parent calls about bus locations have decreased by 80%, and our drivers report better route efficiency. The geofenced notifications give families perfect visibility into arrival times."',
      avatar: avatar,
    },

    demoUrl: 'https://demo.example.com/bus-emergency',

    technicalDetails: {
      architecture: 'Fault-tolerant microservices with failover redundancy',
      notificationTech: ['Push', 'SMS fallback'],
      security: 'FIPS 140-2 compliant encryption',
      deployment: 'Multi-cloud ',
      platforms: ['iOS', 'Android',],

      languages: ['JavaScript', 'Swift', 'Kotlin'],
      frameworks: ['React Native', 'AWS IoT', 'Twilio API', 'Esri ArcGIS']
    }
  },

  bandapp: {
    title: 'Connect Band Mobile Notification App',
    description: 'Official Firstnations Band Mobile Application platform for real-time community updates, service requests, and civic participation',
    summary: 'Nation Connect honors First Nations protocols while modernizing community engagement. Our platform blends traditional governance structures with secure digital tools, ensuring culturally appropriate communication that respects Elder guidance and empowers youth participation.',
    features: [
      'Band Approved Announcements/Updates',
      'Service Request Management System',
      'Pothole/issue reporting with photo uploads',
      'Public hearing participation tools',
      'Council member directories with contact forms',
      'Emergency alerts (weather/closures/events)',
      'Voting location information',
      'Election results and polling information',
      'Community events calendar',
      'Health/social service navigation',

    ],

    testimonial: {
      name: '— Elena Rodriguez',
      role: '',
      text: '"ConnectApp boosted our public meeting attendance by 65% in the first quarter. Residents love the transparent workflow for service requests – we\'ve resolved 3x more infrastructure issues since launch while reducing call center volume."',
      avatar: avatar,
    },

    demoUrl: 'https://demo.example.com/city-engage',

    technicalDetails: {
      architecture: 'Fault-tolerant modularization with failover redundancy',

      security: 'JWT end-to-end encryption',
      deployment: 'Hybrid cloud ',
      platforms: ['iOS', 'Android'],

      languages: ['Javascript', 'Swift', 'Kotlin',],
      frameworks: ['React Native', 'Node.js', 'AWS Lambda']
    }
  },
  library: {
    title: 'Intelligent Library Management System',
    description: 'A smart, scalable solution for managing books, digital media, users, and lending operations across institutions.',
    summary:
      'Our Intelligent Library Management System streamlines library operations through seamless digital media integration. NovaCrest delivers an end-to-end solution designed for schools, universities, and public libraries, offering centralized cataloging, circulation tracking, and analytics to enhance user engagement and operational efficiency.',
    features: [
      'Smart cataloging ',
      'Digital lending of books and materials',
      'Automated due date reminders and fines tracking',
      'Multi-user role-based access control (staff, members, admins)',
      'E-Book viewer for enhanced reading experience',
      'Convenient quick check-in/out',
      'Offline access for rural and remote libraries',
      'Inventory audits with real-time tracking',

      'Detailed analytics dashboards & circulation reports'
    ],

    testimonial: {
      name: '— Sarah Thompson',
      role: 'Chief Librarian,',
      text: '"NovaCrest’s library system has revolutionized how we manage thousands of resources. From cataloging to circulation, everything is intuitive, fast, and reliable. Our patrons love the search, and staff productivity has increased by over 50%."',
      avatar: avatar, // make sure to replace or keep the avatar reference
    },

    demoUrl: 'https://demo.example.com/library-system',

    technicalDetails: {
      architecture: 'Modular monolith with microservices for circulation and cataloging',
      database: ['MongoDB'],
      security: 'Role-based access with audit logs, GDPR compliant',
      deployment: 'Cloud-native (AWS, Azure), supports on-premise',
      platforms: ['Web', 'Windows', 'macOS', 'Android'],
      integrations: ['Google Books API', 'Open Library'],
      languages: ['TypeScript', 'JavaScript', 'Python'],
      frameworks: ['React', 'Node.js', 'Django', 'GraphQL']
    }
  },

  scholartrack: {
    title: 'Smart Scholarship Tracking Application',
    description: 'An intelligent system for managing scholarships, applications, eligibility, disbursements, and student progress across institutions.',
    summary:
      'NovaCrest’s Scholarship Tracking Application empowers educational institutions, governments, and NGOs to efficiently manage scholarship programs. The platform streamlines eligibility screening, application reviews, fund disbursement, and student progress tracking — all in one centralized system. Real-time insights and smart automation ensure transparency and fairness throughout the scholarship lifecycle.',
    features: [
      'Centralized scholarship program management',
      'Automated eligibility verification & scoring',
      'Digital application submission & review workflows',
      'Real-time applicant status tracking',
      'Document upload, validation & storage',
      'Disbursement scheduling with audit trails',
      'Progress reports & academic performance tracking',
      'Role-based access for reviewers, admins & applicants',
      'Alerts & notifications via email',

    ],

    testimonial: {
      name: '— Raven Stone',
      role: 'Scholarship Program Director, ',
      text: '"NovaCrest’s scholarship solution has transformed how we manage our programs. We’ve cut processing time in half and improved transparency for both students and reviewers. "',
      avatar: avatar, // replace or keep your avatar reference
    },

    demoUrl: 'https://demo.example.com/scholarship-app',

    technicalDetails: {
      architecture: 'Modular architecture with secure REST APIs',
      database: ['MongoDB'],
      security: 'JWT end-to-end encryption, GDPR compliant',
      deployment: 'Multi-cloud support (AWS, Azure), supports on-premise',
      platforms: ['Web',],

      languages: ['TypeScript', 'Python', 'JavaScript'],
      frameworks: ['React', 'Django', 'Node.js', 'GraphQL']
    }
  }


}


// ... other projects


const ProjectDetail = () => {
  const { id } = useParams();
  const project = projectData[id];
  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (!project) return <div className="project-detail">Project not found</div>;

  const handleNext = (e) => {
    e.stopPropagation();
    setLightboxIndex((prev) => (prev + 1) % project.images.length);
  };

  const handlePrev = (e) => {
    e.stopPropagation();
    setLightboxIndex((prev) => (prev - 1 + project.images.length) % project.images.length);
  };

  return (
    <div className="project-detail">
      <div className="project-hero">
        <h1>{project.title}</h1>
        <p>{project.description}</p>
      </div>

      <div className="project-content">
        {/* ... (previous sections hidden for brevity, we keep structure) ... */}
        {/* WE NEED TO BE CAREFUL NOT TO REMOVE CONTENT, RE-READING FILE FOR CONTEXT */}
        {/** Key Features **/}
        <h2>Key Features</h2>
        <ul className="feature-list">
          {project.features.map((feat, i) => (
            <li key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FaCheckCircle size={20} style={{ color: '#8f69c8', flexShrink: 0 }} />
              <span>{feat}</span>
            </li>
          ))}
        </ul>

        <div className="project-summary">
          <h3>Project Summary</h3>
          <p>{project.summary}</p>
        </div>
        {/* Technical Details */}
        {project.technicalDetails && (
          <div className="technical-details">
            <h3>Technical Specifications</h3>
            <div className="tech-card-grid">
              {Object.entries(project.technicalDetails).map(([key, value], i) => (
                <div className="tech-card" key={i}>
                  <h4>{key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}</h4>
                  {Array.isArray(value) ? (
                    <ul>
                      {value.map((item, idx) => (
                        <li key={idx}>🔧 {item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>{value}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
        {/* Gallery with Lightbox */}
        {project.images && (
          <div className="project-gallery">
            <h3>Screenshots</h3>
            <div className="gallery-grid">
              {project.images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`Screenshot ${i + 1}`}
                  onClick={() => setLightboxIndex(i)}
                  style={{ cursor: 'pointer' }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Lightbox Modal */}
        {lightboxIndex !== null && project.images && (
          <div className="lightbox" onClick={() => setLightboxIndex(null)}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
              <img src={project.images[lightboxIndex]} alt="Expanded View" />

              {/* Navigation Buttons */}
              {project.images.length > 1 && (
                <>
                  <button className="lightbox-prev" onClick={handlePrev}>&#10094;</button>
                  <button className="lightbox-next" onClick={handleNext}>&#10095;</button>
                </>
              )}

              <button className="lightbox-close" onClick={() => setLightboxIndex(null)}>×</button>
            </div>
          </div>
        )}



        {/* Animated Testimonial */}
        {project.testimonial && (
          <div className="project-testimonial fade-in">
            <h3>What Our Client Says</h3>
            <div className="testimonial-card">
              <img
                src={project.testimonial.avatar}
                alt={project.testimonial.name}
              />
              <blockquote>"{project.testimonial.text}"</blockquote>
              <p>
                <strong>{project.testimonial.name}</strong> –{' '}
                {project.testimonial.role}
              </p>
            </div>
          </div>
        )}

        {/* Live Demo */}
        {project.demoUrl && (
          <>
            <div className="project-demo-card">
              <h3>Contact us to schedule a demo</h3>
              <a href="mailto:contact@novacrest.ca" target="_blank" rel="noopener noreferrer">
                ✉️ Email: contact@novacrest.ca
              </a>
            </div>

          </>
        )}

      </div>

    </div>
  );
};

export default ProjectDetail;
